import queryString from 'query-string';

export const processedQueryString = () => {
    const searchString = decodeURI(window.location.search);
    const obj = queryString.parse(searchString, { arrayFormat: 'bracket' });

    Object.keys(obj).forEach((key) => {
        const isANumber = !Number.isNaN(Number(obj[key]));
        const isNotAString = obj[key] !== '';
        const isNotAnArray = !Array.isArray(obj[key]);

        if (obj[key] === 'false') {
            obj[key] = false;
        } else if (obj[key] === 'true') {
            obj[key] = true;
        } else if (isANumber && isNotAString && isNotAnArray) {
            obj[key] = Number(obj[key]);
        }
    });

    return obj;
};

export default {
    processedQueryString,
};
